import { axiosClient } from "@/shared/api/axios-client";
import type { PolizaApi } from "@/lib/types";

/**
 * Endpoints de pólizas contables de una solicitud · listado + descargas.
 * Las descargas devuelven blobs y disparan el download del browser via
 * anchor temporal (mismo patrón que la auditoría CSV).
 */
async function descargarBlob(url: string, filename: string): Promise<void> {
  const resp = await axiosClient.get<Blob>(url, { responseType: "blob" });
  const objectUrl = window.URL.createObjectURL(resp.data);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

export const contabilizacionApi = {
  listarPolizas: (solicitudId: string) =>
    axiosClient
      .get<PolizaApi[]>(`/api/solicitudes/${solicitudId}/polizas`)
      .then((r) => r.data),

  descargarPolizaTxt: (solicitudId: string, polizaId: string, nombre: string) =>
    descargarBlob(
      `/api/solicitudes/${solicitudId}/polizas/${polizaId}/txt`,
      nombre
    ),

  /** Hotspot 53 · redeposita el TXT de una póliza en error de depósito. */
  reintentarDeposito: (solicitudId: string, polizaId: string) =>
    axiosClient
      .post<PolizaApi>(`/api/solicitudes/${solicitudId}/polizas/${polizaId}/reintentar-deposito`)
      .then((r) => r.data),

  /** Hotspots 53/109 · vuelve a armar una póliza en error (sin TXT o datos inválidos) y la deposita. */
  regenerar: (solicitudId: string, polizaId: string) =>
    axiosClient
      .post<PolizaApi>(`/api/solicitudes/${solicitudId}/polizas/${polizaId}/regenerar`)
      .then((r) => r.data),

  descargarPolizasZip: async (solicitudId: string): Promise<void> => {
    const url = `/api/solicitudes/${solicitudId}/polizas/zip`;
    const resp = await axiosClient.get<Blob>(url, { responseType: "blob" });
    const disposition = String(resp.headers["content-disposition"] ?? "");
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const filename = match?.[1] ?? `polizas-${solicitudId}.zip`;
    const objectUrl = window.URL.createObjectURL(resp.data);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  },
};
